
import styles from './footer.module.css';
import Logo from './Logo.js';
import Pay from './Pay.js';

const Footer = () => {

    return (
        <footer className={styles.footer}>
            <div className={`hidden lg:flex ${styles.logoAndLinks}`}>
                <Logo/>
                <div className={styles.links}>
                    <a href="https://wa.me/420733295086" target="_blank" rel="noopener noreferrer">WhatsApp</a>
                    <a href="https://www.facebook.com/purchasepalaceshop" target="_blank" rel="noopener noreferrer">Facebook</a>
                    <a href="https://www.instagram.com/purchasepalaceshop" target="_blank" rel="noopener noreferrer">Instagram</a>
                    <a href="https://www.tiktok.com/@purchasepalaceshop" target="_blank" rel="noopener noreferrer">TikTok</a>
                </div>
            </div>
            <div className={styles.feedbackForm}>
                {/*<Feedback/>*/}
                <Pay/>
            </div>
       <div className={`${styles.subscribeForm} hidden lg:flex flex-col py-6 px-6 bg-white shadow-lg rounded-lg max-w-md mx-auto text-center`}>
    <h1 className="text-xl font-bold text-gray-800 mb-4">Shopping With Purchase Palace</h1>
    <ol className="text-gray-600 space-y-2 text-left list-decimal list-inside">
        <li>Sign In / Sign Up</li>
        <li>Choose your favorite products</li>
        <li>Add them to your cart</li>
        <li>Go to your cart</li>
        <li>Increase / Decrease quantities</li>
        <li>Proceed to WhatsApp Checkout</li>
    </ol>
    <p className="mt-4 text-sm text-gray-500">Make sure you have WhatsApp installed</p>
</div>

            <div className={styles.copyright}>
                © Purchase Palace, 2026 Maintained & Managed by <a href='https://tech.nexeliumke.co.ke'>Purchase Palace Tech Department</a>
            </div>
        </footer>
    );
};

export default Footer;
